module.exports = __webpack_public_path__ + "img/recent-keyword.7f973079.svg";